import React from 'react';
import { Link } from 'react-router-dom';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import styles from './PlansHeader.module.css';

const ROLE_NOTICE = 'Só a pessoa responsável pela conta ou um administrador pode escolher ou trocar o plano.';

// O título já diz "período de teste" e o selo traz os dias: o subtítulo não repete nenhum dos dois
const trialText = (daysRemaining) => {
  if (daysRemaining === 1) return 'Termina amanhã. Escolha um plano para continuar com tudo, sem interrupção.';
  return 'Escolha um plano para continuar com tudo quando ele terminar, sem interrupção.';
};

/**
 * Título e subtítulo pela situação da conta (mesma ordem dos avisos de antes).
 * Pagamento pendente e cancelamento agendado têm faixa própria, com o botão.
 */
const getCopy = (s) => {
  if (s.hasPlan) {
    return {
      title: `Seu plano: ${s.planName || 'atual'}`,
      subtitle: s.isCanceling
        ? 'O cancelamento está agendado. Para trocar de plano, desfaça o cancelamento primeiro.'
        : 'Você pode trocar de plano a qualquer momento. A alteração é aplicada imediatamente.',
      showDetailsLink: true,
    };
  }
  if (!s.pastDue && s.hadSubscription && !s.showClosureBlock) {
    return {
      title: 'Sua assinatura foi encerrada',
      subtitle: 'Escolha um plano para voltar a usar todos os recursos. Seus dados continuam guardados.',
    };
  }
  if (!s.pastDue && s.trialExpired && !s.showClosureBlock) {
    return {
      title: 'Seu período gratuito terminou',
      subtitle: 'Escolha um plano para continuar utilizando o sistema. Seus dados continuam guardados.',
    };
  }
  if (!s.trialExpired && s.inActiveTrial) {
    return {
      title: 'Você está no período de teste gratuito',
      subtitle: trialText(s.trialDaysRemaining),
      pill: s.trialDaysRemaining > 0
        ? `${s.trialDaysRemaining} ${s.trialDaysRemaining === 1 ? 'dia restante' : 'dias restantes'}`
        : null,
    };
  }
  return {
    title: 'Escolha seu plano',
    subtitle: 'Continue usando a Gabriela sem perder seus dados, agenda e configurações.',
  };
};

/**
 * Cabeçalho da página de Planos.
 * @param {Object} situation — hasPlan, planName, isCanceling, pastDue, hadSubscription,
 *   showClosureBlock, trialExpired, inActiveTrial, trialDaysRemaining, canActivateSubscription
 */
const PlansHeader = ({ situation }) => {
  const copy = getCopy(situation);

  return (
    <header className={styles.header}>
      <div className={styles.texts}>
        <span className={styles.eyebrow}>Planos</span>
        <h1 className={styles.title}>
          {copy.title}
          {copy.pill && <span className={styles.pill}>{copy.pill}</span>}
          {situation.hasPlan && situation.isCanceling && (
            <span className={`${styles.pill} ${styles.pillWarning}`}>Cancelamento agendado</span>
          )}
        </h1>
        <p className={styles.subtitle}>{copy.subtitle}</p>
        {!situation.canActivateSubscription && (
          <p className={styles.roleNotice}>
            <LockOutlinedIcon className={styles.roleIcon} />
            {ROLE_NOTICE}
          </p>
        )}
      </div>

      {copy.showDetailsLink && (
        <Link to="/subscription/details" className={styles.detailsLink}>
          Detalhes da assinatura
          <ArrowForwardIcon className={styles.detailsIcon} />
        </Link>
      )}
    </header>
  );
};

export default PlansHeader;
